// src/ManageContractProfiles.js - NUOVO FILE

import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { useUser } from './UserContext';
import { logAction } from './loggingService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import './ManageContractProfiles.css';

// Modale per creare/modificare un profilo (POTENZIATO)
function ProfileModal({ profile, onSave, onClose }) {
    const [profileData, setProfileData] = useState({
    name: '',
    type: '',
    level: '',
    ccnl: '',
    weeklyHours: 40,
   monthlyVacationAccrual: 2.16, // Esempio: 26 / 12
monthlyRolAccrual: 3.33,
    exFestivita: 32,
    // --- NUOVI CAMPI ---
    hourlyGrossCost: 0,
    overtimeRate: 0,
    taxPercentage: 0
});

    useEffect(() => {
        if (profile) {
            setProfileData({ ...profileData, ...profile });
        }
    }, [profile]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfileData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        if (!profileData.name.trim()) {
            toast.error("Il nome del profilo è obbligatorio.");
            return;
        }
        onSave({
            id: profile?.id,
            ...profileData,
            weeklyHours: Number(profileData.weeklyHours) || 0,
            monthlyVacationAccrual: Number(profileData.monthlyVacationAccrual) || 0,
monthlyRolAccrual: Number(profileData.monthlyRolAccrual) || 0,
            exFestivita: Number(profileData.exFestivita) || 0,
        });
    };

    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content modal-content-large" onMouseDown={e => e.stopPropagation()}>
                <h3>{profile ? 'Modifica Profilo' : 'Nuovo Profilo Contrattuale'}</h3>
                <div style={{ textAlign: 'left', marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div className="form-group">
                        <label>Nome Profilo</label>
                        <input type="text" name="name" value={profileData.name} onChange={handleChange} placeholder="Es. Segreteria - IV Livello Commercio"/>
                    </div>
                    <div className="form-row">
                        <div className="form-group" style={{flex: 2}}>
                            <label>Tipo Contratto</label>
                            <input type="text" name="type" value={profileData.type} onChange={handleChange} placeholder="Es. Tempo Indeterminato" />
                        </div>
                         <div className="form-group" style={{flex: 1}}>
                            <label>Ore Settimanali</label>
                            <input type="number" name="weeklyHours" value={profileData.weeklyHours} onChange={handleChange} />
                        </div>
                    </div>
                     <div className="form-row">
                        <div className="form-group" style={{flex: 1}}>
                            <label>Livello</label>
                            <input type="text" name="level" value={profileData.level} onChange={handleChange} placeholder="Es. 4°" />
                        </div>
                        <div className="form-group" style={{flex: 1}}>
                            <label>CCNL</label>
                            <input type="text" name="ccnl" value={profileData.ccnl} onChange={handleChange} placeholder="Es. Commercio" />
                        </div>
                    </div>
                    <hr style={{margin: '10px 0'}} />
                    <div className="form-row">
    <div className="form-group" style={{flex: 1}}>
        <label>Rateo Ferie MENSILE (giorni)</label>
        <input type="number" step="0.01" name="monthlyVacationAccrual" value={profileData.monthlyVacationAccrual} onChange={handleChange} placeholder="Es. 2.16" />
    </div>
    <div className="form-group" style={{flex: 1}}>
        <label>Rateo ROL MENSILE (ore)</label>
        <input type="number" step="0.01" name="monthlyRolAccrual" value={profileData.monthlyRolAccrual} onChange={handleChange} placeholder="Es. 3.33" />
    </div>
    <div className="form-group" style={{flex: 1}}>
        <label>Ex Festività (ore una tantum)</label>
        <input type="number" name="exFestivita" value={profileData.exFestivita} onChange={handleChange} />
    </div>
</div>
                </div>
                <hr style={{margin: '15px 0'}} />
<h4>Parametri Economici Standard</h4>

<div className="form-row">
    <div className="form-group" style={{flex: 1}}>
        <label>Paga Oraria Lorda (€)</label>
        <input type="number" step="0.01" name="hourlyGrossCost" value={profileData.hourlyGrossCost} onChange={handleChange} />
    </div>
    <div className="form-group" style={{flex: 1}}>
        <label>Straordinario (€/h)</label>
        <input type="number" step="0.01" name="overtimeRate" value={profileData.overtimeRate} onChange={handleChange} />
    </div>
</div>

<div className="form-row" style={{marginTop: '10px'}}>
    <div className="form-group" style={{flex: 1}}>
        <label>Tasse / Costo Azienda (%)</label>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
            <input type="number" name="taxPercentage" value={profileData.taxPercentage} onChange={handleChange} style={{flex: 1}} />
            <span>%</span>
        </div>
    </div>
</div>
                <div style={{marginTop: '25px'}}>
                    <button onClick={handleSave} className="modal-button confirm-button">Salva</button>
                    <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
                </div>
            </div>
        </div>
    );
}


function ManageContractProfiles() {
    const { userProfile } = useUser();
    const navigate = useNavigate(); // Inizializza useNavigate
    const [profiles, setProfiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingProfile, setEditingProfile] = useState(null);

    const fetchProfiles = async () => {
    setIsLoading(true);

    // Controllo di sicurezza per centerId
    if (!userProfile || !userProfile.centerId) {
        setIsLoading(false);
        setProfiles([]); // Assicura che i profili siano vuoti
        return;
    }

    // Usa il nuovo percorso nidificato
    const snapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'contractProfiles'));
    const profilesList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setProfiles(profilesList.sort((a, b) => a.name.localeCompare(b.name)));
    setIsLoading(false);
};

    useEffect(() => {
        fetchProfiles();
    }, [userProfile]); // <-- MODIFICA QUI

    const handleSave = async (profileData) => {
        if (profileData.id) {
            // Modifica
            const docRef = doc(db, 'centers', userProfile.centerId, 'contractProfiles', profileData.id); // <-- MODIFICA QUI
            await updateDoc(docRef, profileData);
            await logAction(userProfile, `ha modificato il profilo contrattuale: ${profileData.name}`);
            toast.success("Profilo aggiornato!");
        } else {
    // Creazione
    const { id, ...dataToSave } = profileData; // Rimuove il campo 'id' prima di salvare
    dataToSave.centerId = userProfile.centerId;
    await addDoc(collection(db, 'centers', userProfile.centerId, 'contractProfiles'), dataToSave); // <-- MODIFICA QUI
    await logAction(userProfile, `ha creato il profilo contrattuale: ${dataToSave.name}`);
    toast.success("Profilo creato!");
}
        setIsModalOpen(false);
        setEditingProfile(null);
        fetchProfiles();
    };

    const handleDelete = async (profile) => {
        if (window.confirm(`Sei sicuro di voler eliminare il profilo "${profile.name}"?`)) {
            await deleteDoc(doc(db, 'centers', userProfile.centerId, 'contractProfiles', profile.id)); // <-- MODIFICA QUI
            await logAction(userProfile, `ha eliminato il profilo contrattuale: ${profile.name}`);
            toast.warn("Profilo eliminato.");
            fetchProfiles();
        }
    };

    const openModal = (profile = null) => {
        setEditingProfile(profile);
        setIsModalOpen(true);
    };

    return (
        <>
            {isModalOpen && <ProfileModal profile={editingProfile} onSave={handleSave} onClose={() => setIsModalOpen(false)} />}
            
            <div className="management-container contract-profiles-page" style={{ maxWidth: '1300px', margin: '20px auto', padding: '20px' }}>
                <div className="management-header">
                    <h4>Gestione Profili Contrattuali</h4>
                    <div style={{display: 'flex', gap: '10px'}}>
                        <button onClick={() => openModal()} className="add-new-button">+ Nuovo Contratto</button>
                    </div>
                </div>

                <div className="management-list">
    {isLoading ? <p>Caricamento profili...</p> : profiles.map(profile => (
        <div key={profile.id} className="management-card">
            <div className="list-item-content">
                <div className="card-top-row">
                    <span className="list-item-main-text">{profile.name}</span>
                </div>
                
                <div className="profile-details-grid">
                    {/* Riga singola */}
                    <div className="profile-detail-row">
                        <span>Tipo Contratto:</span>
                        <span className="profile-detail-value">{profile.type || 'N/D'}</span>
                    </div>

                    {/* Riga con Livello e Ore Sett */}
                    <div className="profile-detail-row-multi">
                        <div className="multi-item">
                            <span>Livello: <span className="profile-detail-value">{profile.level || 'N/D'}</span></span>
                        </div>
                        <div className="multi-item">
                            <span>Ore Sett: <span className="profile-detail-value">{profile.weeklyHours}h</span></span>
                        </div>
                    </div>
                    
                    {/* Riga con Ferie, ROL e Ex Fest - MODIFICATA */}
<div className="profile-detail-row-multi small-font">
    <div className="multi-item">
        {/* Mostriamo il Rateo Mensile invece del totale annuo */}
        <span>Rateo M. Ferie: <span className="profile-detail-value">{profile.monthlyVacationAccrual} gg</span></span>
    </div>
    <div className="multi-item">
        {/* Mostriamo il Rateo Mensile invece del totale annuo */}
        <span>Rateo M. ROL: <span className="profile-detail-value">{profile.monthlyRolAccrual} h</span></span>
    </div>
    <div className="multi-item">
        <span>Ex Fest: <span className="profile-detail-value">{profile.exFestivita} h</span></span>
    </div>
</div>
                </div>
            </div>
            <div className="list-item-actions">
                <button onClick={() => openModal(profile)} className="info-button">Modifica</button>
                <button onClick={() => handleDelete(profile)} className="delete-button">Elimina</button>
            </div>
        </div>
    ))}
</div>

                {!isLoading && profiles.length === 0 && ( <p style={{ textAlign: 'center', color: '#888', marginTop: '40px' }}>
                    Nessun profilo contrattuale trovato. Clicca su "+ Nuovo Profilo" per iniziare.</p> )}
            </div>
        </>
    );
}

export default ManageContractProfiles;